/**
 * 能力上下文：只提供 context 与消费 hook，不放组件。
 *
 * Provider 组件单独放在 CapabilityProvider.tsx ——
 * 因为 react-refresh 要求"导出组件的文件只导出组件"，
 * 混在一起会让该文件在 HMR 时整页重载而不是热更新。
 *
 * 为什么要有这个 context：探测必须全应用只跑一次。
 * `collectRuntimeFacts()` 会创建 WebGL 上下文，而浏览器对同一页面的活动 WebGL
 * 上下文数量有限（约 16 个）。若每个页面各自探测，导航几次额度就耗光，
 * 之后 3D 视口拿不到上下文 —— 表现为"切几个页面后导演台黑屏"，极难定位。
 */
import { createContext, useContext } from 'react';

import type { CapabilityView } from '../platform/useCapability';

export const CapabilityContext = createContext<CapabilityView | null>(null);

export function useAppCapability(): CapabilityView {
  const ctx = useContext(CapabilityContext);
  if (ctx === null) {
    throw new Error('useAppCapability 必须在 CapabilityProvider 内使用');
  }
  return ctx;
}
